import { BreadcrumbPlugin } from "bootstrap-vue"

export default {
  install(Vue, options) {
    Vue.prototype.$Global = {
      //酒測結果
      AlcoholTestResultList:[],
      //處理timezone 的object
      TimeZoneObject: {
        convertTimeZone : function(date, timeZone)
        {
          //en-US (美國時間格式的意思，最後有用moment.js轉換成user想要的格式，所以這邊只是給一個固定格式去轉換不影響最後的格式)
          if(timeZone == null){
            timeZone = 'Europe/London'
            return new Date(date.toLocaleString('en-US', { timeZone }))
          }else{
            return new Date(date.toLocaleString('en-US', { timeZone }))
          }
        },
        difference : function(day1, day2) {  
          return ((day2.getTime()-day1.getTime())/1000/60/60).toFixed(2)
        },
        //取得TimeZone Minute
        getTimeZoneMin:function(timeZone) {
          if(timeZone == null || timeZone == ''){
            timeZone = 'Europe/London'
          }
          var currentTime = new Date('2023-03-20 00:00:00')
          var timeZoneTime = new Date(currentTime.toLocaleString('en-US',{timeZone}))
          var UTCTime = new Date(currentTime.toISOString().split('T')[0] + ' '+ currentTime.toISOString().split('T')[1].split('.')[0])
          var TimeZone=this.difference(UTCTime,timeZoneTime)
          return TimeZone*60
        },
        //UTC+Time zone 日期時間 轉 UTC日期時間
        TimeZoneDateToUTC : function(DateTime,ZoneType){
          var TimeZone = 0;
          if(ZoneType == null){
            ZoneType = 'Europe/London'
            //計算數字Time zone
            TimeZone = this.difference(this.convertTimeZone(DateTime, ZoneType),DateTime)
            DateTime.setTime(DateTime.setMinutes(DateTime.getMinutes() + TimeZone*60))
            return DateTime.toISOString()
          }else{
            //計算數字Time zone
            TimeZone = this.difference(this.convertTimeZone(DateTime, ZoneType),DateTime)
            DateTime.setTime(DateTime.setMinutes(DateTime.getMinutes() + TimeZone*60))
            return DateTime.toISOString()
          }
        },
        //UTC日期時間 轉 UTC+Time zone 日期時間
        UTCToTimeZoneDate : function(UTCTime,ZoneType){
          var LocalTime = new Date(UTCTime)
          var LocalTimeAddTimeZone;
          if(ZoneType == null){
            ZoneType = 'Europe/London'
            LocalTimeAddTimeZone = this.convertTimeZone(LocalTime,ZoneType)
          }else{
            LocalTimeAddTimeZone = this.convertTimeZone(LocalTime,ZoneType)
          }
          return LocalTimeAddTimeZone
        }
      },
      //設定視窗滑動
      setMove(){
        var elementSelected;
        var mouseX, mouseY;
        var zIndex = 0;
        document.querySelectorAll(".move").forEach( function(element,index) {
          element.addEventListener('mousedown', function(event) {
            elementSelected = element;
            mouseX = event.clientX - parseInt(getComputedStyle(elementSelected).left);
            mouseY = event.clientY - parseInt(getComputedStyle(elementSelected).top);
            // move this element to top layer
            if(zIndex > 0){
              zIndex = 0
            }
            elementSelected.style['z-index'] = ++zIndex;
            //document.querySelector(".container").appendChild(elementSelected);
          })
        });
    
        document.addEventListener('mousemove', function(event) {  
          if(elementSelected!==undefined) {
            elementSelected.style.left = event.clientX - mouseX + 'px';
            elementSelected.style.top = event.clientY - mouseY + 'px';
          }
        });
    
        document.addEventListener('mouseup', function(event) {
          elementSelected = undefined;
        });
      },
      //刪除cookie
      delete_cookie(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      },
      //將GoogleKey加入網頁
      AddGoogleKey(googlemapkey){
        var googletag = document.createElement('script')
        googletag.src = 'https://maps.googleapis.com/maps/api/js?key='+googlemapkey
        localStorage.setItem('GoogleKey',googlemapkey)
        var app = document.getElementById('app')
        app.append(googletag)
      },
      // 找尋多樹根的車隊樹 目標車隊ID的所有子子孫孫車隊 (treeArray:多樹根的車隊樹,targetFleetID:目標車隊ID)
      getDescendantFleetIDsForMultipleRoots(treeArray, targetFleetID) {
        let fleetIDs = [];
      
        // 遍歷每個樹根
        treeArray.forEach(tree => {
          fleetIDs.push(...this.getDescendantFleetIDs(tree, targetFleetID));
        });
      
        return fleetIDs.join(",");
      },
      // 單棵樹的遞迴處理
      getDescendantFleetIDs(tree, targetFleetID) {
        let result = [];
      
        // 遍歷樹結構
        function traverse(node) {
          if (node.fleetId === targetFleetID) {
            collectDescendants(node);
          } else if (node.subFleets) {
            node.subFleets.forEach(subFleet => traverse(subFleet));
          }
        }
      
        // 收集子孫節點 FleetID
        function collectDescendants(node) {
          if (node.subFleets) {
            node.subFleets.forEach(subFleet => {
              result.push(subFleet.fleetId);
              collectDescendants(subFleet);
            });
          }
        }
      
        traverse(tree);
        return result;
      },
      GetfleetsTree(){
        // this.load = true
        Vue.prototype.$APIjs.GetfleetsTree(localStorage.getItem('token')).then(result=>{
          // this.load = false
          if(result.obj != undefined){
            Vue.prototype.$Manage.treeData = result.obj
          }
        })
      },
      //固定方向 東
      getUnitsrc(Obj){
        var IconPath = ''
        var ImgSrc = ''
        if(Obj.objectIconPath === undefined){
        }
        switch (Obj.objectIconPath.toLowerCase()) {
            case 'cars':
                IconPath = 'Car'
                break;
            case 'ambulance':
                IconPath = 'ambulance'
                break;
            case 'bus':
                IconPath = 'bus'
                break;
            case 'bus2':
                IconPath = 'bus2'
                break;
            case 'dumptruck':
                IconPath = 'DumpTruck'
                break;
            case 'excavator':
                IconPath = 'Excavator'
                break;
            case 'freightliner':
                IconPath = 'Freightliner'
                break; 
            case 'grader':
                IconPath = 'grader'
                break;
            case 'motorGrader':
                IconPath = 'MotorGrader'
                break; 
            case 'people':
                IconPath = 'people'
                break; 
            case 'plate':
                IconPath = 'Plate'
                break; 
            case 'motocycle':
                IconPath = 'Scooter'
                break;  
            case 'trailer':
                IconPath = 'trailer'
                break;  
            case 'truck':
                IconPath = 'Truck'
                break;        
            default:
                IconPath = 'Car'
                break;
        }
        var Color = '7'
        if(Obj.accState != null){
            switch (Obj.accState) {
                case 0:
                    Color = '0'
                    break;
                case 1:
                    Color = '1'
                    break;
                case false:
                    Color = '0'
                    break;
                case true:
                    Color = '1'
                    break;
                default:
                    Color = '0'
                    break;
            }
            //判斷Idle
            if((Obj.accState==1 || Obj.accState==true) && Obj.lastIdleStartDateTime!=null){
                Color = '5'
            }
        }
        if(Obj.connectionState === 0){
            Color = '7'
        }
        ImgSrc =  require('../static/images/MapIcon/'+IconPath+'/CHeadE_S'+Color+'.gif')
        return ImgSrc
      },
      CheckTokenIntervalID:0,
      FindFuncNo1:false,
      FindFuncIndex:0,
      maintItemList:[],
      DashBoardTime:' 00:00:00',
      DashBoardFleetID:0,
      ReportFleetID:0,
      FirstEntryDashBoardQueryNum:0,
      DashBoardSubFleet:false,
      GlobalOffline:false,
      priorityList:'',
      BackgroundColor:'',
      version:'4.2606.3',
      SettingSubmit:0, 
      MapType:'Leaflet',
      LogMode:'',
      Mode:'globe',
      ml:'mlforsetbar',
      Menuml:'Menuml',
      timeformat:'',
      SettingBarCSS:'SettingBar-on',
      MenuCss:'Menu-on',
      CurrentPage:'',
      lang:'en-us',//預設語言
      langObj:'',
      EventLanguageObj:'',
      FocusZoom:19,
      fullWidth:0,
      fullHeight:0,
      load:false,
      showskinbtn:true,
      MaintanceInputShow:false,
      showImgexample:false,
      Unit_local:'km',
      managepage:1,
      LogManagePage:0,//Manage 初始畫面
      LogReportPage:0,//Report 初始畫面
      CanNotBeBlank:' cannot be blank.',
      NoSelect:'No selected.',
      Unit:'',
      TableShow:false,
      ContentShow:true,
      FreeMode:'true',
      SettingShow:false,
      ChangeLangNum:0,
      EventNewShow:false,
      Noneactive:'',
      MapCtrlShowArr:[true,true,true,true,true,false,true,false,false],
      Eventdef:[],
      FleetObj:{
        subFleets:[],
        fleetId:0,
        fleetName:'',
      },
      FavoriteUnitObj:[],
      MenuObj:[
        { 
          floor:0,
          index:6,
          root: true,
          name: "Basic",
          children:[
            {
              floor:1,
              index:8,
              name: "Manage Account",
            },
            {
              floor:1,
              index:7,
              name: "Manage Fleet",
            },
            {
              floor:1,
              index:9,
              name: "Manage Vehicle",
            },
            {
              floor:1,
              index:23,
              name: "Manage Vehicle",
            },
            {
              floor:1,
              index:10,
              name: "Manage Driver",
            },
            {
              floor:1,
              index:12,
              name: "Fleet POI",
            },
            {
              floor:1,
              index:15,
              name: "Fleet AT Command",
            },
            {
              floor:1,
              index:19,
              name: "Maintenance Schedule",
            },
            {
              floor:1,
              index:4,
              name: "Maintenance List",
            },
            {
              floor:1,
              index:5,                
              name: "Maintenance Report",
            },
          ]
        },
        { 
          floor:0,
          index:0,
          root: true,
          name: "Video",
          children:[
            {
              floor:1,
              index:1,
              name: "UDID Manage",
            },
            {
              floor:1,
              index:2,                
              name: "Basic Data Manage",
            },
          ]
        },
        // { 
        //   floor:0,
        //   index:3,
        //   root: true,
        //   name: "Maintenance",
        //   children:[
 
        //   ]
        // },
        { 
          floor:0,
          index:11,
          root: true,
          name: "Advance",
          children:[
            {
              floor:1,
              index:13,
              name: "Fleet Geofence Setting",
            },
            {
              floor:1,
              index:14,
              name: "Fleet Geofence Assign",
            },
            {
              floor:1,
              index:22,
              name: "Fleet Event Setup"
            },
            {
              floor:1,
              index:16,
              name: "Batch Command",
            },
            {
              floor:1,
              index:21,
              name: "Manage(V2)",
            },
            {
              floor:1,
              index:25,
              name: "Config Service"
            }
          ]
        },
        { 
          floor:0,
          index:17,
          root: true,
          name: "Admin Tool",
          children:[
            {
              floor:1,
              index:18,
              name: "Function Authority Setting",
            },
            {
              floor:1,
              index:20,
              name: "Manage Line Binding(User)",
            },
            //加管理步驟 1 加入Tree
            {
              floor:1,
              index:24,
              name: "Manage Line Binding(Group)"
            }
          ]
        },
      ],
      ReportMenuObj:[
        { 
          floor:0,
          index:0,
          root: true,
          name: "Basic",
          children:[
            {
              floor:1,
              index:1,
              name: "Position Log Detail",
            },
            {
              floor:1,
              index:2,                
              name: "Trip Detail",
            },
            {
              floor:1,
              index:4,                
              name: "Paired Event Detail",
            },
            {
              floor:1,
              index:5,                
              name: "Alert Event Detail",
            },
            {
              floor:1,
              index:6,                
              name: "Trip Summary",
            },
            {
              floor:1,
              index:7,                
              name: "Mileage Day Summary",
            },
            {
              floor:1,
              index:8,                
              name: "Mileage Month Summary",
            },
            {
              floor:1,
              index:9,                
              name: "Fuel Estimation Month Summary",
            },
            {
              floor:1,
              index:10,                
              name: "Event Summary",
            },
            {
              floor:1,
              index:11,                
              name: "Vehicle Alive Report",
            },
            {
              floor:1,
              index:18,                
              name: "Days of Use Month Summary",
            },
            {
              floor:1,
              index:20,                
              name: "Working Time Day Summary",
            },
            {
              floor:1,
              index:21,                
              name: "Working Time Month Summary",
            },
            {
              floor:1,
              index:22,                
              name: "Cold Chain Temperature Report",
            },
            //加報表步驟 1 加入Tree
            {
              floor:1,
              index:23,
              name: "CANGO Detail"
            },
            {
              floor:1,
              index:24,
              name: "CAN_VOTA Detail"
            }
          ]
        },
        { 
          floor:0,
          index:3,
          root: true,
          name: "Advance",
          children:[
            {
              floor:1,
              index:12,                
              name: "Report(V2.5)",
            },
            {
              floor:1,
              index:14,                
              name: "Report(Rollingtrans)",
            },
            //開會討論再議
            {
              floor:1,
              index:13,                
              name: "運転出勤日報",
            },
            {
              floor:1,
              index:19,                
              name: "Login History Detail",
            },
            {
              floor:1,
              index:25,
              name: "Breath Alcohol Test Report"
            }
          ]
        },
        { 
          floor:0,
          index:15,
          root: true,
          name: "Report manager",
          children:[
            {
              floor:1,
              index:16,                
              name: "Auto Email",
            },
            {
              floor:1,
              index:17,                
              name: "Backup Files Download",
            },
          ]
        },
      ],
      timeobjstart:[
        '00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00',
        '13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'
      ],
      timeobjend:[
        '00:59','01:59','02:59','03:59','04:59','05:59','06:59','07:59','08:59','09:59','10:59','11:59','12:59',
        '13:59','14:59','15:59','16:59','17:59','18:59','19:59','20:59','21:59','22:59','23:59'
      ],
      theme:'',
      ChangeModeToGlobeNum:0,
      SetThemeNum:0,
      Geofencecheckbox:false,
      FleetEventDef:[],
      authorityDefine:{
        "AT00":false,
        "AT01":false,
        "AT02":false,
        //加管理步驟 3 加入新權限
        "AT03":false,
        "DB00":false,
        "DP00":false,
        "HT00":false,
        "MA00":false,
        "MA99":false,
        "MA05":false,
        "MB00":false,
        "MV00":false,
        "RA00":false,
        "RA01":false,
        "RA02":false,
        "RA03":false,
        "RA04":false,
        "RA05":false,
        "RB00":false,
        "RB01":false,
        "RB02":false,
        "RB03":false,
        "RB04":false,
        "RB05":false,
        "RB06":false,
        "RB07":false,
        "RB08":false,
        "RB09":false,
        "RB10":false,
        "RB11":false,
        "RB12":false,
        "RB13":false,
        "RB14":false,
        //加報表步驟 3 加入新權限
        "RB15":false,
        "RB16":false,
        "RM00":false,
        "RM01":false,
        "RM02":false,
        "TK00":false,
        "UL00":false,
        "VD00":false,
        "MA01":false,
        "MA02":false,
        "MA03":false,
        "MA04":false,
        "MB01":false,
        "MB02":false,
        "MB03":false,
        "MB04":false,
        "MB05":false,
        "MB06":false,
        "MB07":false,
        "MB08":false,
        "MB09":false,
        "MB031":false,
        "MB032":false,
        "GL00":false,
        "GL01":false
      },
      //登出
      Logout(Type){
        console.log(localStorage.getItem('Customer'))
        if(localStorage.getItem('Customer') !=undefined && localStorage.getItem('Customer') !=null && localStorage.getItem('Customer') != 'null'){
          window.location.href = jsonObject['LoginCenter_']+localStorage.getItem('Customer') +'/?RedirectUrl='+jsonObject['SolutionName']+'&Type='+Type
        }else{
          window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type='+Type
        }
      },
      //機型ID轉機型
      PrtoIDtoProtoCode(PortoID){
        // console.log(PortoID)
        // console.log(Vue.prototype.$Manage.ProtocolUnitList)
        if(Vue.prototype.$Manage.ProtocolUnitList.unitProtocol){
          for(var i = 0 ; i< Vue.prototype.$Manage.ProtocolUnitList.unitProtocol.length ; i++){
            if(PortoID == Vue.prototype.$Manage.ProtocolUnitList.unitProtocol[i].pK_ProtoID){
              return Vue.prototype.$Manage.ProtocolUnitList.unitProtocol[i].protoCode
            }
          }
        }
        return ''
      },
      //分鐘轉hh:mm
      minutesToHHMM(minutes) {
        var hours = Math.floor(minutes / 60);
        var remainingMinutes = minutes % 60;
        var hoursStr = String(hours).padStart(2, '0');
        var minutesStr = String(remainingMinutes).padStart(2, '0');
        return hoursStr + ':' + minutesStr;
      },
      //取得車隊事件定義表
      getFleetEventDef(){
        Vue.prototype.$APIjs.GetFleetEventDef(localStorage.getItem('token')).then(result=>{
          if(result.obj.fleetEventDefs){
            this.FleetEventDef = result.obj.fleetEventDefs
          }
        }) 
      },
      //ID取得車隊名稱
      getFleetName(id){
        if(this.FleetObj.subFleets){
          for(var i=0 ; i<this.FleetObj.subFleets.length;i++){
            if(this.FleetObj.subFleets[i].fleetId == id){
              return this.FleetObj.subFleets[i].fleetName
            }
          }
        }
      },
      //事件ID 轉換成事件名稱
      EventIDConvertToEventName(EventID,FleetID){
        var EventName = ''
        if(EventID !=0 && (EventID == '' || EventID ==undefined || EventID ==-1)){
          return ''
        }
        if(this.FleetEventDef.length != 0 && this.FleetEventDef != undefined){
          var FleetEventDef = this.FleetEventDef.filter(item => item.fK_FleetID === FleetID);
          for(var z=0 ; z<FleetEventDef.length;z++){
            if(EventID == FleetEventDef[z].fK_ReportID){
              EventName = FleetEventDef[z].eventName
              break;
            }
          }
        }
        if(EventName == ''){
          //沒有自定義跑翻譯
          for(var i = 0 ; i<Vue.prototype.$Report.EventResourceArr.length;i++){
            if(EventID == Vue.prototype.$Report.EventResourceArr[i].eventReportID){
              EventName = this.EventLanguageObj[this.lang][Vue.prototype.$Report.EventResourceArr[i].languageKey]
              break;
            }
          }
        }
        return EventName
      },
      //事件ID 轉換成 語系index
      EventIDConvertToLanguageKey(EventID){
        console.log(EventID)
        if(EventID !=0 && (EventID == '' || EventID ==undefined || EventID ==-1)){
          return ''
        }
        for(var i = 0 ; i<Vue.prototype.$Report.EventResourceArr.length;i++){
          if(EventID == Vue.prototype.$Report.EventResourceArr[i].eventReportID){
            console.log(Vue.prototype.$Report.EventResourceArr[i].languageKey)
            return Vue.prototype.$Report.EventResourceArr[i].languageKey
          }
        }
      },
      //事件ID 偵測Event Alert
      EventIDEventAlert(EventID,Obj){
        //Geofence Entry Geofence Exit
        for(var i = 0 ; i<Vue.prototype.$Report.EventResourceArr.length;i++){
          if(EventID == Vue.prototype.$Report.EventResourceArr[i].eventReportID && Vue.prototype.$Report.EventResourceArr[i].eventAlert == 1){
            if(EventID == 164 || EventID == 165){
              //由左至右消失
              // Vue.prototype.$toast.error(Obj.identifier + ' ' +  this.EventLanguageObj[this.lang][this.EventIDConvertToLanguageKey(EventID)] + ' ' + Obj.zoneName, {
              //   timeout: 5000,
              //   showCloseButtonOnHover: true,
              //   icon: false,
              // });
              Toastify({
                text: Obj.identifier + ' ' +  this.EventIDConvertToEventName(EventID,Vue.prototype.$Vehicle.FleetID) + ' ' + Obj.zoneName,
                duration: 10000,
                newWindow: true,
                gravity: "top", // `top` or `bottom`
                position: "center",
                backgroundColor: "#FF5151"
              }).showToast();
            }else{
              //由左至右消失
              // Vue.prototype.$toast.error(Obj.identifier + ' ' + this.EventLanguageObj[this.lang][this.EventIDConvertToLanguageKey(EventID)], {
              //   timeout: 5000,
              //   showCloseButtonOnHover: true,
              //   icon: false,
              // });
              Toastify({
                text: Obj.identifier + ' ' + this.EventIDConvertToEventName(EventID,Vue.prototype.$Vehicle.FleetID),
                duration: 10000,
                newWindow: true,
                gravity: "top", // `top` or `bottom`
                position: "center",
                backgroundColor: "#FF5151"
              }).showToast();
            }
            break;
          }
        }
      },
      //使用者層級控制
      UserLevelControl(Level){
        if(atob(Vue.prototype.$cookie.get('ul')).split('SYS')[1].split('TECH')[0] > Level){
          return false
        }else{
          return true
        }
      },
      //依照速度改變車機顏色
      SpeedChangeColor(speed,item){
        if(speed >= 0 && speed<= 40){
          Vue.prototype.$set(item,'arrowColor','green')
        }else if(speed>= 41 && speed<= 70){
          Vue.prototype.$set(item,'arrowColor','yellow')
        }else if(speed>= 71 && speed<= 100){
          Vue.prototype.$set(item,'arrowColor','orange')
        }else if(speed> 100){
          Vue.prototype.$set(item,'arrowColor','red')
        }else{
          Vue.prototype.$set(item,'arrowColor','green')
        }
      },
      //依照事件改變顏色
      EventDefChangeColor(eventType,item){
        switch (eventType) {
          case 'S':
            Vue.prototype.$set(item,'color','red')
            break;
          case 'E':
            Vue.prototype.$set(item,'color','red')
            break;
          case 'A':
            Vue.prototype.$set(item,'color','orange')
            break;
          default:
            Vue.prototype.$set(item,'color','green')
            break;
        }
      },
      //轉換日期格式
      FixCurrentTime(){
        var Date_ = new Date().toISOString().split('.')[0].replaceAll('-','/').replaceAll('T',' ')
        switch (localStorage.getItem('timeformat')) {
          case 'DD/MM/YYYY':
            Date_ = Date_.split(' ')[0].split('/')[2] + '/' +Date_.split(' ')[0].split('/')[1]+ '/' +Date_.split(' ')[0].split('/')[0] + ' ' + Date_.split(' ')[1]
            break;
          case 'MM/DD/YYYY':
            Date_ = Date_.split(' ')[0].split('/')[1]+ '/' +Date_.split(' ')[0].split('/')[2]+ '/' +Date_.split(' ')[0].split('/')[0] + ' ' + Date_.split(' ')[1]
            break;   
          case 'YYYY/MM/DD':
            
            break;   
          default:
            break;
        }
        return Date_
      },
      //新增事件點位
      AddACCOnOffMarker(Obj,eventReportID){
        switch (this.MapType) {
          case 'Google':
            // console.log(eventReportID)
            if(Obj){
              for(var i=0 ; i <Obj.length ; i++){
                if(Obj[i].reportId == eventReportID){
                  Vue.prototype.$GoogleMap.AddOverlayMarker(Obj[i].latitude,Obj[i].longitude,'','HistoryACCOnOffMarker',Obj[i])
                }
              }
            }
            break;
          case 'Leaflet':
            // console.log(eventReportID)
            if(Obj){
              //建立Maker 樣式
              for(var i=0 ; i <Obj.length ; i++){
                if(Obj[i].reportId == eventReportID){
                  Vue.prototype.$LeafletMap.AddMarker(Obj[i],i,'HistoryACCOnOffMarker')
                }
              }
              //打點上去
              if(Vue.prototype.$LeafletMap.AccOnOffmarkers.length > 0){
                Vue.prototype.$LeafletMap.AddAccOnOffciLayer()
              }
            }
            break;       
          default:
            break;
        }
      },
      //新增車機 或 歷史軌跡
      //根據不同頁面Reset不同Marker
      AddMarkerforPage(){
        switch (this.CurrentPage) {
          case 'Vehicle':
            this.AddUnitMarker()
            break;
          case 'History':
            //this.$Global.RemoveHistory()
            setTimeout(() => { //等待ChangeMap結束
            if(Vue.prototype.$History.UnitDateTimeHistoryObj != ''){
              if(Vue.prototype.$History.TraceLineCheckboxValue){
                this.AddHistoryTraceline(Vue.prototype.$History.UnitDateTimeHistoryObj)
              }
              if(Vue.prototype.$History.TraceCheckboxValue){
                Vue.prototype.$LeafletMap.markers = []
                //打箭頭點位
                this.AddHistoryPathMark(Vue.prototype.$History.UnitDateTimeHistoryObj)
                switch (this.MapType) {
                  case 'Google':
                    break;
                  case 'Leaflet':
                    if(Vue.prototype.$LeafletMap.ciLayer != ''){
                      Vue.prototype.$LeafletMap.RemoveciLayer()
                    }
                    if(Vue.prototype.$LeafletMap.markers.length > 0){
                      Vue.prototype.$LeafletMap.AddciLayer()
                    }
                    break;          
                  default:
                    break;
                }
              }
              Vue.prototype.$LeafletMap.AccOnOffmarkers = []
              //打AccOnOff點位
              switch (this.MapType) {
                case 'Google':
                  this.AddACCOnOffMarker(Vue.prototype.$History.UnitDateTimeHistoryObj,Vue.prototype.$History.eventPositionID)
                  break;
                case 'Leaflet':
                  if(Vue.prototype.$LeafletMap.AccOnOffciLayer != ''){
                    Vue.prototype.$LeafletMap.RemoveAccOnOffciLayer()
                  }
                 this.AddACCOnOffMarker(Vue.prototype.$History.UnitDateTimeHistoryObj,Vue.prototype.$History.eventPositionID)
                  break;          
                default:
                  break;
              }
              Vue.prototype.$History.StopTrackHistory()
              Vue.prototype.$History.AddHistiryUnit(Vue.prototype.$History.UnitDateTimeHistoryObj[Vue.prototype.$History.HistoryCurrentNum-1])
            }
            }, 100);
            break;          
          default:
            break;
        }
      },
      //切換Map 渲染電子圍籬
      AddGeofence(){
        if(this.Geofencecheckbox){
          //等待ChangeMap結束
          setTimeout(() => {
            switch (this.MapType) {
              case 'Google':
                Vue.prototype.$GoogleMap.AddGeofence(Vue.prototype.$Vehicle.FleetGeofenceObj)
                break;
              case 'Leaflet':
                Vue.prototype.$LeafletMap.AddGeofence(Vue.prototype.$Vehicle.FleetGeofenceObj)
                break; 
            }
          }, 100);
        }
      },
      //更換車隊刪除電子圍籬
      RemoveGeofence(){
        switch (this.MapType) {
          case 'Google':
            Vue.prototype.$GoogleMap.RemoveGeofence()
            break;
          case 'Leaflet':
            Vue.prototype.$LeafletMap.RemoveGeofence()
            break; 
        }
      },
      //深拷貝
      DeepCopyFunc(Object){
        var clonedata = JSON.parse(JSON.stringify(Object))
        return clonedata
      },
      //印出Vue ref element by PDF
      printRef(Document,TableName) {
        //iframe輸出
        var pdfframe = window.frames["print_frame"]
        // console.log(divElements)
        pdfframe.window.document.write(Document);
        document.title = TableName + ' ' + new Date().toLocaleString()
        pdfframe.window.focus();
        pdfframe.window.print();
        pdfframe.document.body.innerHTML = ''
        document.title = 'INTELLI FLEETWEB'
        //直接輸出
        // //Get the HTML of whole page
        // var oldPage = document.body.innerHTML;
        // //Reset the page's HTML with div's HTML only
        // document.body.innerHTML = 
        //     "<html><head><title></title></head><body>" + divElements + "</body>";
        // document.title = Name + ' ' + new Date().toLocaleString()
        // //Print Page
        // window.print();
        // //Restore orignal HTML
        // document.body.innerHTML = oldPage;
        // document.title = 'INTELLI FLEETWEB'
      },
      //圖表轉圖片
      convertChartToImage(chartId, callback) {
        var chartInstance = echarts.getInstanceByDom(document.getElementById(chartId));
        if (chartInstance) {
            var backgroundColor = "#ffffff"
            if(localStorage.getItem('theme') == 'black'){
              backgroundColor = "#121528"
            }
            var imageDataURL = chartInstance.getDataURL({
                type: 'png',
                pixelRatio: 2,
                backgroundColor: backgroundColor
            });
            callback && callback(imageDataURL);
        } else {
            console.error("ECharts instance not found for chart ID: " + chartId);
        }
      },
      //匯出PDF
      ExportPDF(Name,thead,table,header,ChartID){
        var titleheader = ''
        var titleheaderarr = []
        var titleheaderstr= ''
        if(header != undefined && header != null){
          titleheader = header
          // console.log(titleheader)
          titleheaderarr = titleheader.replaceAll("<thead>","").replaceAll("</thead>","").
          replaceAll("<th>","").replaceAll("<tr>","").replaceAll("</tr>","<br>").
          replaceAll(" ","").replaceAll("\n","").replaceAll("\t","").split("</th>")
          for(var i = 0 ; i < titleheaderarr.length ; i++){
            if(titleheaderarr[i]==""){
              titleheaderstr = titleheaderstr + titleheaderarr[i] + "&emsp;&emsp;"
            }else{
              titleheaderstr = titleheaderstr + titleheaderarr[i]
            }
          }
        }
        // console.log(table)
        var theadArr = ''
        for(var i = 0 ; i <thead.length;i++){
          theadArr = theadArr + '<th>'+thead[i].name+'</th>'
        }
        var tbodyall = ''
        for(var j=0 ;j<table.length;j++){
          var tbodyArr = ''
          for(var i = 0 ; i <thead.length;i++){
            tbodyArr = tbodyArr + '<td>'+table[j][thead[i].index]+'</td>'
          }
          tbodyArr = '<tr>'+tbodyArr+'</tr>'
          tbodyall = tbodyall + tbodyArr
        }
        var pdfframe = window.frames["print_frame"]
        pdfframe.window.document.write(`
          <body>
            <title>`+ Name + ' '+  new Date().toLocaleString()+`</title>
            `+titleheaderstr+`
            <table class="table">
              <thead>
                <tr>
                `+theadArr+`
                </tr>
              </thead>
              <tbody>
                `+tbodyall+`           
              </tbody>
            </table>
          </body>
          <style>
            table
            {
                border: 1px solid #333;
                border-collapse: collapse;
                -webkit-print-color-adjust:exact;
            }
            table th
            {
                background-color: #c2c2c2;
                color: #333;
                font-weight: bold;
                -webkit-print-color-adjust:exact;
            }
            table th, table td
            {
                padding: 5px;
                border: 1px solid #333;
                -webkit-print-color-adjust:exact;
            }
          </style>
        `);
        document.title = Name + ' ' + new Date().toLocaleString()
        if(ChartID != undefined && ChartID!=null){
          this.convertChartToImage(ChartID, function(imageDataURL) {
            var img = new Image();
            img.style.width = '100%';
            img.style.height = 'auto';
            img.src = imageDataURL;
            pdfframe.document.body.appendChild(img);
            setTimeout(() => {
              pdfframe.window.focus();
              pdfframe.window.print();
              pdfframe.document.body.innerHTML = ''
              document.title = 'INTELLI FLEETWEB'
            }, 1000);
          });
        }else{
          pdfframe.window.focus();
          pdfframe.window.print();
          pdfframe.document.body.innerHTML = ''
          document.title = 'INTELLI FLEETWEB'
        }
      },
      //取得TimeZone
      getTimeZone(FleetID){
        if(Vue.prototype.$Global.FleetObj.fleetId == FleetID){
          return Vue.prototype.$Global.FleetObj.fleetTimeZone
        }
        for(var i = 0 ; i<Vue.prototype.$Global.FleetObj.subFleets.length;i++){
          if(Vue.prototype.$Global.FleetObj.subFleets[i].fleetId == FleetID){
            // console.log('2')
            return Vue.prototype.$Global.FleetObj.subFleets[i].fleetTimeZone
          }
        }
      },
      //控制管理頁面 換頁
      RouteManagePage(route){
        switch (this.CurrentPage) {
          case 'Manage':
            this.LogManagePage = this.managepage
            if(this.managepage != 4){//不等於MaintenanceList
              this.MaintanceInputShow = false
            }
            switch (this.managepage) {
              case 1:
                route.push({ name: 'UDIDManage' }).catch(()=>{})
                break;  
              case 2:
                route.push({ name: 'BasicDataManage' }).catch(()=>{})
                break;  
              case 4:
                route.push({ name: 'MaintanceList' }).catch(()=>{})
                break;
              case 5:
                route.push({ name: 'MaintanceReport' }).catch(()=>{})
                break;
              case 7:
                route.push({ name: 'ManageGroup' }).catch(()=>{})
                break;
              case 8:
                route.push({ name: 'ManageAccount' }).catch(()=>{})
                break;
              case 9:
                route.push({ name: 'ManageVehicle' }).catch(()=>{})
                break;
              case 10:
                route.push({ name: 'ManageDriver' }).catch(()=>{})
                break;     
              case 12:
                route.push({ name: 'ManagePOI' }).catch(()=>{})
                break;
              case 13:
                route.push({ name: 'ManageGeofence' }).catch(()=>{})
                break;
              case 14:
                route.push({ name: 'ManageGeofenceAssign' }).catch(()=>{})
                break; 
              case 15:
                route.push({ name: 'ManageFleetATCommand' }).catch(()=>{})
                break;   
              case 16:
                route.push({ name: 'BatchCommand' }).catch(()=>{})
                break;  
              case 18:
                route.push({ name: 'FunctionAuthoritySetting' }).catch(()=>{})
                break;
              case 19:
                route.push({ name: 'MaintenanceSchedule' }).catch(()=>{})
                break;
              case 20:
                route.push({ name: 'ManageLineBinding' }).catch(()=>{})
                break;
              case 22:
                route.push({ name: 'FleetEventSetup' }).catch(()=>{})
                break; 
              case 23:
                route.push({ name: 'ManageVehicle_New' }).catch(()=>{})
                break; 
                //加管理步驟 7 控制route
              case 24:
                route.push({ name: 'ManageLineBindingGroup' }).catch(()=>{})
                break;
              case 25:
                route.push({ name: 'ConfigService' }).catch(()=>{})
              default:
                break;
            }
            break;
          case 'Report':
            this.LogReportPage = this.managepage
            switch (this.managepage) {
              case 1:
                route.push({ name: 'PositionLogDetail' }).catch(()=>{})
                break;  
              case 2:
                route.push({ name: 'TripDetail' }).catch(()=>{})
                break;
              case 4:
                route.push({ name: 'CombolEventDetail' }).catch(()=>{})
                break;
              case 5:
                route.push({ name: 'AlertEventDetail' }).catch(()=>{})
                break;     
              case 6:
                route.push({ name: 'TripSummary' }).catch(()=>{})
                break;
              case 7:
                route.push({ name: 'MileageDaySummary' }).catch(()=>{})
                break;
              case 8:
                route.push({ name: 'MileageMonthSummary' }).catch(()=>{})
                break;
              case 9:
                route.push({ name: 'FuelEstimationMonthSummary' }).catch(()=>{})
                break;
              case 10:
                route.push({ name: 'EventSummary' }).catch(()=>{})
                break;
              case 11:
                route.push({ name: 'VehicleAliveReport' }).catch(()=>{})
                break;   
              case 13:
                route.push({ name: 'ShippingDailyReport' }).catch(()=>{})
                break; 
              case 16:
                route.push({ name: 'AutoEmail' }).catch(()=>{})
                break; 
              case 17:
                route.push({ name: 'BackupFilesDownload' }).catch(()=>{})
                break;
              case 18:
                route.push({ name: 'DaysOfUseMonthSummary' }).catch(()=>{})
                break; 
              case 19:
                route.push({ name: 'LoginHistoryDetail' }).catch(()=>{})
                break;    
              case 20:
                route.push({ name: 'WorkTimeDaySummary' }).catch(()=>{})
                break;
              case 21:
                route.push({ name: 'WorkTimeMonthSummary' }).catch(()=>{})
                break;
              case 22:
                route.push({ name: 'ColdChainTemperatureReport' }).catch(()=>{})
                break;
              case 23://加報表步驟 7 控制route
                route.push({ name: 'CANGODetail'}).catch(()=>{}) 
                break;
              case 24:
                route.push({ name: 'CANVOTADetail'}).catch(()=>{}) 
                break;
              case 25:
                route.push({ name: 'BreathAlcoholTestReport'}).catch(()=>{}) 
                break;                  
              default:
                break;
            }
            break;        
          default:
            break;
        }
      },
      // 設定localStorage
      SetlocalStorage(){
        var Lang = localStorage.getItem('Lang')
        var Unit = localStorage.getItem('Unit')
        var theme = localStorage.getItem('theme')
        var timeformat = localStorage.getItem('timeformat')
        var UnitDetailtheadShow = localStorage.getItem('UnitDetailtheadShow')
        var HistoryDetailthead = localStorage.getItem('HistoryDetailthead')
        var Vehiclethead = localStorage.getItem('Vehiclethead')
        var Historythead = localStorage.getItem('Historythead')
        var account = localStorage.getItem('Logaccount')
        var Customer = localStorage.getItem('Customer')
        localStorage.clear();
        localStorage.setItem('Lang',Lang)
        localStorage.setItem('Unit',Unit)
        localStorage.setItem('theme',theme)
        localStorage.setItem('timeformat',timeformat)
        localStorage.setItem('UnitDetailtheadShow',UnitDetailtheadShow)
        localStorage.setItem('HistoryDetailthead',HistoryDetailthead)
        localStorage.setItem('Historythead',Historythead)
        localStorage.setItem('Vehiclethead',Vehiclethead)
        localStorage.setItem('Logaccount',account)
        localStorage.setItem('UnitHighNumber',jsonObject.OnePageVehicleNum)
        localStorage.setItem('Customer',Customer)
      },
      //取得車隊列表
      GetFleet(){
        // Vue.prototype.$APIjs.GetEventDefinition(localStorage.getItem('token'),1).then(result=>{
        //   Vue.prototype.$Global.Eventdef = result.obj
          Vue.prototype.$APIjs.GetFleet(localStorage.getItem('token')).then(result=>{
            if(result.obj.googleAPIKey != null){
              Vue.prototype.$Global.AddGoogleKey(result.obj.googleAPIKey)
              //Google 剛要到key要緩衝一下
              //2023/10/03 預設Map判斷
              if(result.obj.defaultMap == 1){
                setTimeout(() => {
                  Vue.prototype.$Global.MapType = 'Google'
                }, 1800);
              }else{
                Vue.prototype.$Global.MapType = 'Leaflet'
              }
            }else{
              Vue.prototype.$Global.AddGoogleKey('')
            }
            Vue.prototype.$Global.FleetObj = result.obj
            Vue.prototype.$Vehicle.FleetID = result.obj.fleetId
            // Vue.prototype.$History.FleetID = result.obj.fleetId
          })
        // })
      },
      //控制mapcontrol 顯示及消失
      setMapCtrlShowArr(Page){
        switch (Page) {
          case 'Vehicle':
            // if(!Vue.prototype.$Vehicle.MultiViewChckbox){
            this.MapCtrlShowArr = [true,true,true,true,true,false,true,false,true]
            // }else{
            //   this.MapCtrlShowArr = [false,false,true,false,false,false]
            // }
            break;
          case 'History':
            this.MapCtrlShowArr = [false,false,true,true,false,true,false,true,false]
            break;        
          default:
            break;
        }
      },
      //轉換數字為 第幾
      OneConvertToFirst(Number){
        switch (Number) {
          case 1:
            return '1st'
          case 2:
            return '2nd';
          case 3:
            return '3rd'
          case 4:
            return '4th';    
          case 5:
            return '5th'
          case 6:
            return '6th';    
          case 7:
            return '7th'
          case 8:
            return '8th';
          case 9:
            return '9th';
          case 10:
            return '10th';
          default:
            break;
        }
      },
      //例:FatigueSensor format="YY-M-D-H-m-s"
      formatUTCToCustom(utcString,format) {
        return Vue.prototype.moment.utc(utcString).format(format);
      },
      //轉換日期格式
      FixTimeFormat(Date){
        return Vue.prototype.moment(Date).format(localStorage.getItem('timeformat'))
      },
      //轉換日期時間格式
      FixDateTimeFormat(Date){
        return Vue.prototype.moment(Date).format(localStorage.getItem('timeformat') + ' HH:mm:ss')
      },
      //用timzone 轉時間 及 轉換日期格式
      GetDateFromSTring(DateString,TimeZone) {
        var DateStringZ = DateString + '.000Z' 
        var date = this.TimeZoneObject.UTCToTimeZoneDate(DateStringZ,TimeZone)
        // let arr = DateString.split(/[- : T]/);
        // let date = new Date();
        // date.setFullYear(arr[0]);
        // date.setMonth(arr[1] - 1);
        // date.setDate(arr[2]);
        // date.setHours(arr[3]);
        // date.setMinutes(arr[4]);
        // date.setSeconds(arr[5]);
        // date.setMinutes(date.getMinutes()+TimeZone);
        return Vue.prototype.moment(date).format( localStorage.getItem('timeformat')+" HH:mm:ss");
      },
      //角度取得方位
      DegreeDirection(DirectionValue){
        if ((DirectionValue >= 338) || (DirectionValue < 22)) {
            return 'N';
        }
        else if ((DirectionValue >= 22) && (DirectionValue < 68)) {
            return 'NE';
        }
        else if ((DirectionValue >= 68) && (DirectionValue < 113)) {
            return 'E';
        }
        else if ((DirectionValue >= 113) && (DirectionValue < 158)) {
            return 'SE';
        }
        else if ((DirectionValue >= 158) && (DirectionValue < 203)) {
          return 'S';
        }
        else if ((DirectionValue >= 203) && (DirectionValue < 248)) {
          return 'SW';
        }
        else if ((DirectionValue >= 248) && (DirectionValue < 293)) {
          return 'W';
        }
        else if ((DirectionValue >= 293) && (DirectionValue < 338)) {
          return 'NW';
        }
      },
      //ACC STATE 取得 翻譯後的名稱
      NumtoACC(Num,accType){
        //取ACC key
        var accON = ''
        var accOFF = ''
        // console.log(accType)
        if(Vue.prototype.$Manage.ACCTypeList){
          if(Vue.prototype.$Manage.ACCTypeList.length>0){
            for(var i = 0 ; i<Vue.prototype.$Manage.ACCTypeList.length;i++){
              if(Vue.prototype.$Manage.ACCTypeList[i].accType == accType){
                accON = Vue.prototype.$Manage.ACCTypeList[i].oN_KeyWord
                accOFF = Vue.prototype.$Manage.ACCTypeList[i].ofF_KeyWord
              }
            }
          }
        }
        // console.log(accON)
        // console.log(accOFF)
        switch (Num) {
          case 0:
            return this.langObj[this.lang][accOFF] 
          case 1:
            return this.langObj[this.lang][accON] 
          case false:
            return this.langObj[this.lang][accOFF] 
          case true:
            return this.langObj[this.lang][accON]
          default:
            break;
        }
      },
      //刪除MAP
      RemoveMap(){
        document.getElementById('weathermap').innerHTML = "<div id='"+this.CurrentPage+"map' style='width: 100%; height: 100%;'></div>";
      },
      //處理權限
      FixMenuByPriority(){
        // console.log(this.authorityDefine)
        //下方的要先處理 不然會處理不對位置
        // 報表管理
        if(!this.authorityDefine['RM01'] || this.authorityDefine['RM01']==undefined){
          this.ReportMenuObj[2].children = this.ReportMenuObj[2].children.filter(function (item){
            return item.index != 16;
          });
        }
        if(!this.authorityDefine['RM02'] || this.authorityDefine['RM02']==undefined){
          this.ReportMenuObj[2].children = this.ReportMenuObj[2].children.filter(function (item){
            return item.index != 17;
          });
        }
        if(!this.authorityDefine['RM00'] || this.authorityDefine['RM00']==undefined){
          this.ReportMenuObj = this.ReportMenuObj.filter(function (item){
            return item.index != 15;
          })
        }
        // 進階報表
        if(!this.authorityDefine['RA01'] || this.authorityDefine['RA01']==undefined){
          this.ReportMenuObj[1].children = this.ReportMenuObj[1].children.filter(function (item){
            return item.index != 12;
          });
        }
        if(!this.authorityDefine['RA02'] || this.authorityDefine['RA02']==undefined){
          this.ReportMenuObj[1].children = this.ReportMenuObj[1].children.filter(function (item){
            return item.index != 14;
          });
        }
        if(!this.authorityDefine['RA03'] || this.authorityDefine['RA03']==undefined){
          this.ReportMenuObj[1].children = this.ReportMenuObj[1].children.filter(function (item){
            return item.index != 13;
          });
        }
        if(!this.authorityDefine['RA04'] || this.authorityDefine['RA04']==undefined){
          this.ReportMenuObj[1].children = this.ReportMenuObj[1].children.filter(function (item){
            return item.index != 19;
          });
        }
        if(!this.authorityDefine['RA05'] || this.authorityDefine['RA05']==undefined){
          this.ReportMenuObj[1].children = this.ReportMenuObj[1].children.filter(function (item){
            return item.index != 25;
          });
        }
        if(!this.authorityDefine['RA00']){
          this.ReportMenuObj = this.ReportMenuObj.filter(function (item){
            return item.index != 3;
          })
        }
        // 基本報表
        if(!this.authorityDefine['RB01'] || this.authorityDefine['RB01']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 1;
          });
        }
        if(!this.authorityDefine['RB02'] || this.authorityDefine['RB02']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 2;
          });
        }
        if(!this.authorityDefine['RB03'] || this.authorityDefine['RB03']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 4;
          });
        }
        if(!this.authorityDefine['RB04'] || this.authorityDefine['RB04']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 5;
          });
        }
        if(!this.authorityDefine['RB05'] || this.authorityDefine['RB05']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 6;
          });
        }
        if(!this.authorityDefine['RB06'] || this.authorityDefine['RB06']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 7;
          });
        }
        if(!this.authorityDefine['RB07'] || this.authorityDefine['RB07']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 8;
          });
        }
        if(!this.authorityDefine['RB08'] || this.authorityDefine['RB08']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 9;
          });
        }
        if(!this.authorityDefine['RB09'] || this.authorityDefine['RB09']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 10;
          });
        }
        if(!this.authorityDefine['RB10'] || this.authorityDefine['RB10']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 11;
          });
        }
        if(!this.authorityDefine['RB11'] || this.authorityDefine['RB11']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 18;
          });
        }
        if(!this.authorityDefine['RB12'] || this.authorityDefine['RB12']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 20;
          });
        }
        if(!this.authorityDefine['RB13'] || this.authorityDefine['RB13']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 21;
          });
        }
        if(!this.authorityDefine['RB14'] || this.authorityDefine['RB14']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 22;
          });
        }
        //加報表步驟 4 加入權限判斷 步驟 5 新增.vue檔 例:CANGODetail.vue
        if(!this.authorityDefine['RB15'] || this.authorityDefine['RB15']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 23;
          });
        }
        if(!this.authorityDefine['RB16'] || this.authorityDefine['RB16']==undefined){
          this.ReportMenuObj[0].children = this.ReportMenuObj[0].children.filter(function (item){
            return item.index != 24;
          });
        }
        // 系統管理者工具->Function Authority Setting
        if(!this.authorityDefine['AT01']){
          this.MenuObj[3].children = this.MenuObj[3].children.filter(function (item){
            return item.index != 18;
          });
        }
        // 系統管理者工具->Manage Line Binding(User)
        if(!this.authorityDefine['AT02']){
          this.MenuObj[3].children = this.MenuObj[3].children.filter(function (item){
            return item.index != 20;
          });
        }
        //加管理步驟 4 加入權限判斷 步驟 5 新增.vue檔
        // 系統管理者工具->Manage Line Binding(Group)
        if(!this.authorityDefine['AT03']){
          this.MenuObj[3].children = this.MenuObj[3].children.filter(function (item){
            return item.index != 24;
          });
        }
        // 系統管理者工具
        if(!this.authorityDefine['AT00']){
          this.MenuObj = this.MenuObj.filter(function (item){
            return item.index != 17;
          });
        }
        // 進階管理->V2管理
        if(!this.authorityDefine['MA99'] || this.authorityDefine['MA99']==undefined){
          this.MenuObj[2].children = this.MenuObj[2].children.filter(function (item){
            return item.index != 21;
          });
        }
        if(!this.authorityDefine['MA01'] || this.authorityDefine['MA01']==undefined){
          this.MenuObj[2].children = this.MenuObj[2].children.filter(function (item){
            return item.index != 13;
          });
        }
        if(!this.authorityDefine['MA02'] || this.authorityDefine['MA02']==undefined){
          this.MenuObj[2].children = this.MenuObj[2].children.filter(function (item){
            return item.index != 14;
          });
        }
        if(!this.authorityDefine['MA03'] || this.authorityDefine['MA03']==undefined){
          this.MenuObj[2].children = this.MenuObj[2].children.filter(function (item){
            return item.index != 16;
          });
        }
        if(!this.authorityDefine['MA04'] || this.authorityDefine['MA04']==undefined){
          this.MenuObj[2].children = this.MenuObj[2].children.filter(function (item){
            return item.index != 22;
          });
        }
        if(!this.authorityDefine['MA05'] || this.authorityDefine['MA05']==undefined){
          this.MenuObj[2].children = this.MenuObj[2].children.filter(function (item){
            return item.index != 25;
          });
        }
        // 進階管理
        if(!this.authorityDefine['MA00']){
          this.MenuObj = this.MenuObj.filter(function (item){
            return item.index != 11;
          });
        }
        // 攝影機
        if(!this.authorityDefine['MV00']){
          this.MenuObj = this.MenuObj.filter(function (item){
            return item.index != 0;
          });
        }
        //基本管理
        if(!this.authorityDefine['MB01']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 8;
          });
        }
        if(!this.authorityDefine['MB02']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 7;
          });
        }
        if(!this.authorityDefine['MB03']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 9;
          });
        }
        if(!this.authorityDefine['MB032']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 23;
          });
        }
        if(!this.authorityDefine['MB04']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 10;
          });
        }
        if(!this.authorityDefine['MB05']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 12;
          });
        }
        if(!this.authorityDefine['MB06']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 15;
          });
        }
        if(!this.authorityDefine['MB07']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 19;
          });
        }
        if(!this.authorityDefine['MB08']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 4;
          });
        }
        if(!this.authorityDefine['MB09']){
          this.MenuObj[0].children = this.MenuObj[0].children.filter(function (item){
            return item.index != 5;
          });
        }
      },
      //更換Manage Menu語系
      ChangeManageMenuLang(){
        this.CanNotBeBlank = ' '+this.langObj[this.lang].cannot_be_blank
        this.Recursive(this.MenuObj)
        this.Recursive_Report(this.ReportMenuObj)
      },
      //更換語系  Menu Report Recursive
      Recursive_Report(Obj){
        for(var i=0 ; i<Obj.length ; i++){
          switch (Obj[i].index) {
            case 0:
              Obj[i].name = this.langObj[this.lang].basic
              break;
            case 1:
              Obj[i].name = this.langObj[this.lang].positionLogDetail
              break;
            case 2:
              Obj[i].name = this.langObj[this.lang].tripDetail
              break;
            case 3:
              Obj[i].name = this.langObj[this.lang].advance
              break; 
            case 4:
              Obj[i].name = this.langObj[this.lang].pairedEventDetail
              break; 
            case 5:
              Obj[i].name = this.langObj[this.lang].alertEventDetail
              break;
            case 6:
              Obj[i].name = this.langObj[this.lang].tripSummary
              break;
            case 7:
              Obj[i].name = this.langObj[this.lang].mileageDaySummary
              break;
            case 8:
              Obj[i].name = this.langObj[this.lang].mileageMonthSummary
              break;
            case 9:
              Obj[i].name = this.langObj[this.lang].fuelEstimationMonthSummary
              break; 
            case 10:
              Obj[i].name = this.langObj[this.lang].eventSummary
              break; 
            case 11:
              Obj[i].name = this.langObj[this.lang].vehicleAliveReport
              break;
            case 12:
              Obj[i].name = this.langObj[this.lang].report + '(V2.5)'
              break; 
            case 14:
              Obj[i].name = this.langObj[this.lang].report + '(Rollingtrans)'
              break; 
            case 15:
              Obj[i].name = this.langObj[this.lang].report_manage
              break; 
            case 16:
              Obj[i].name = this.langObj[this.lang].auto_email
              break;    
            case 17:
              Obj[i].name = this.langObj[this.lang].backup_files_download
              break;
            case 18:
              Obj[i].name = this.langObj[this.lang].days_of_use_month_summary
              break; 
            case 19:
              Obj[i].name = this.langObj[this.lang].login_history_detail
              break;
            case 20:
              Obj[i].name = this.langObj[this.lang].workingTimeDaySummary
              break; 
            case 21:
              Obj[i].name = this.langObj[this.lang].workingTimeMonthSummary
              break;
            case 22:
              Obj[i].name = this.langObj[this.lang].coldChainTemperatureReport
              break; 
            case 23 : //加報表步驟 2 加入更改名稱為多語系
              Obj[i].name = this.langObj[this.lang].cangoDetail 
              break;
            case 24 :
              Obj[i].name = this.langObj[this.lang].CanVotaDetail 
              break; 
            case 25 :
              Obj[i].name = this.langObj[this.lang].BreathAlcoholTestReport 
              break;    
            default:
              break;
          }
          if(Obj[i].children == undefined){
          }else{
            this.Recursive_Report(Obj[i].children)
          }
        }
      },
      //找出第一個有權限的報表或管理
      RecursiveFindIndex(Obj){
        for(var i=0 ; i<Obj.length ; i++){
          if(Obj[i].floor != 0){
            this.FindFuncNo1 = true
            this.FindFuncIndex = Obj[i].index
            break;
          }
          if(!this.FindFuncNo1){
            if(Obj[i].children == undefined){
            
            }else{
              this.RecursiveFindIndex(Obj[i].children)
            }
          }
        }
      },
      //更換語系  Menu Manage Recursive
      Recursive(Obj){
        for(var i=0 ; i<Obj.length ; i++){
          switch (Obj[i].index) {
            case 0:
              Obj[i].name = this.langObj[this.lang].video
              break;
            case 1:
              Obj[i].name = this.langObj[this.lang].UDID_Manage
              break;
            case 2:
              Obj[i].name = this.langObj[this.lang].basic_Data_Manage
              break;
            case 3:
              Obj[i].name = this.langObj[this.lang].maintenance
              break; 
            case 4:
              Obj[i].name = this.langObj[this.lang].maintenance_Record_List
              break; 
            case 5:
              Obj[i].name = this.langObj[this.lang].maintenance_Report
              break;
            case 6:
              Obj[i].name = this.langObj[this.lang].basicManage
              break;
            case 7:
              Obj[i].name = this.langObj[this.lang].manageFleet
              break;
            case 8:
              Obj[i].name = this.langObj[this.lang].manageAccount
              break;
            case 9:
              Obj[i].name = this.langObj[this.lang].manageVehicle
              break; 
            case 10:
              Obj[i].name = this.langObj[this.lang].managedriver
              break;   
            case 11:
              Obj[i].name = this.langObj[this.lang].advanceManage
              break;
            case 12:
              Obj[i].name = this.langObj[this.lang].fleetPOI
              break;
            case 13:
              Obj[i].name = this.langObj[this.lang].fleetGeofenceSetting
              break;
            case 14:
              Obj[i].name = this.langObj[this.lang].fleetGeoFenceAssign
              break;      
            case 15:
              Obj[i].name = this.langObj[this.lang].fleetATCommand
              break;
            case 16:
              Obj[i].name = this.langObj[this.lang].batchCommand
              break; 
            case 17:
              Obj[i].name = this.langObj[this.lang].adminTool
              break; 
            case 18:
              Obj[i].name = this.langObj[this.lang].functionAuthoritySetting
              break;
            case 19:
              Obj[i].name = this.langObj[this.lang].maintenance_schedule
              break;
            case 20:
              Obj[i].name = this.langObj[this.lang].manageLineBinding + '('+this.langObj[this.lang].user+')'
              break;
            case 21:
              Obj[i].name = this.langObj[this.lang].manage_v2
              break;
            case 22:
              Obj[i].name = this.langObj[this.lang].fleetEventSetup
              break;
            case 23:
              Obj[i].name = this.langObj[this.lang].manageVehicle
              break;
            case 24://加管理步驟 2 名稱更改為多語系
              Obj[i].name = this.langObj[this.lang].manageLineBinding + '('+this.langObj[this.lang].group+')'
              break;
            case 25:
              Obj[i].name = this.langObj[this.lang].ConfigService
            default:
              break;
          }
          if(Obj[i].children == undefined){
          }else{
            this.Recursive(Obj[i].children)
          }
        }
      },
      //卡空值欄位判斷
      Blankfunc(cannot_blank,Obj){
        var blank_str = ''
        for(var i=0 ;i<cannot_blank.length;i++){
          switch (cannot_blank[i].type) {
            case 'null':
              if(Obj[cannot_blank[i].index] == null || Obj[cannot_blank[i].index] == 'null'){
                if(blank_str == ''){
                  blank_str = blank_str + cannot_blank[i].name
                }else{
                  blank_str = blank_str +','+  cannot_blank[i].name
                }
              }
              break;
            case 'arr':
              if(Obj[cannot_blank[i].index] == [] || Obj[cannot_blank[i].index][0] == ''){
                if(blank_str == ''){
                  blank_str = blank_str + cannot_blank[i].name
                }else{
                  blank_str = blank_str +','+  cannot_blank[i].name
                }
              }
              break;
            case 'str':
              if(Obj[cannot_blank[i].index] == ''){
                if(blank_str == ''){
                  blank_str = blank_str + cannot_blank[i].name
                }else{
                  blank_str = blank_str +','+  cannot_blank[i].name
                }
              }
              break;
            case 'num2':
              if(Obj[cannot_blank[i].index] === -1 || Obj[cannot_blank[i].index] === '' || Obj[cannot_blank[i].index] === null){
                if(blank_str == ''){
                  blank_str = blank_str + cannot_blank[i].name
                }else{
                  blank_str = blank_str +','+  cannot_blank[i].name
                }
              }
            break;
            case 'num':
                if(Obj[cannot_blank[i].index] == 0 || Obj[cannot_blank[i].index] == '' || Obj[cannot_blank[i].index] == null){
                  if(blank_str == ''){
                    blank_str = blank_str + cannot_blank[i].name
                  }else{
                    blank_str = blank_str +','+  cannot_blank[i].name
                  }
                }
              break;
            case 'obj':
              if(Obj[cannot_blank[i].index].length >0){
                for(var j=0; j<Obj[cannot_blank[i].index].length;j++){
                  for(var k=0;k<cannot_blank[i].indexarr.length;k++){
                    if(cannot_blank[i].indexarr[k].index == 'unitPrice'){
                      if(Obj[cannot_blank[i].index][j][cannot_blank[i].indexarr[k].index] == ''){
                        if(blank_str == ''){
                          blank_str = blank_str + cannot_blank[i].name
                        }else{
                          blank_str = blank_str +',' + cannot_blank[i].name
                        }
                        break;
                      }
                    }else{
                      if(Obj[cannot_blank[i].index][j][cannot_blank[i].indexarr[k].index] == '' || Obj[cannot_blank[i].index][j][cannot_blank[i].indexarr[k].index] == 0){
                        if(blank_str == ''){
                          blank_str = blank_str + cannot_blank[i].name
                        }else{
                          blank_str = blank_str +',' + cannot_blank[i].name
                        }
                        break;
                      }
                    }
                  }
                  if(k != cannot_blank[i].indexarr.length){
                    break;
                  }
                }
              }
              break; 
            case 'multiselect':
              if(Obj[cannot_blank[i].index].length < 1){
                if(blank_str == ''){
                  blank_str = blank_str + cannot_blank[i].name
                }else{
                  blank_str = blank_str +',' + cannot_blank[i].name
                }
              }
              // if(Obj[cannot_blank[i].index].length > 0 && Obj[cannot_blank[i].index] != undefined){
              //   var j;
              //   for(j = 0 ; j<Obj[cannot_blank[i].index].length ; j++){
              //     if(Obj[cannot_blank[i].index][j].check){
              //       break;
              //     }
              //   }
              //   //全部都次false 沒選任一選項
              //   if(j == Obj[cannot_blank[i].index].length){
              //     if(blank_str == ''){
              //       blank_str = blank_str + cannot_blank[i].name
              //     }else{
              //       blank_str = blank_str +',' + cannot_blank[i].name
              //     }
              //   }
              // }
              break;      
            default:
              break;
          }
        }
        return blank_str
      },
      //日期相減
      getDateMinus(day2,day1){
        var difference = Math.abs(day2-day1);
        var days = difference/(1000 * 3600 * 24)
        return days
      },
      //取得昨天
      getYestoday(){
        var day1 = new Date(); 
        day1.setDate(day1.getDate() - 1);
        return this.Format(day1)
      },
      //取得TimeZone  昨天
      getTimeZoneYestoday(TimeZone){
        var day = new Date(); 
        if(TimeZone != undefined){
          day = this.TimeZoneObject.convertTimeZone(day,TimeZone)
        }
        day.setDate(day.getDate() - 1);
        return this.Format(day)
      },
      //取得TimeZone  今天
      getToday(TimeZone){
        var day = new Date();
        if(TimeZone != undefined){
          day = this.TimeZoneObject.convertTimeZone(day,TimeZone)
        }
        return this.Format(day)
      },
      //取得TimeZone  這個月第一天
      getFirstday(TimeZone){
        var day = new Date();
        if(TimeZone != undefined){
          day = this.TimeZoneObject.convertTimeZone(day,TimeZone)
        }
        day =  new Date(day.setDate(1))
        return this.Format(day)
      },
      //日期格式轉換
      Format(time) {
        const today = time;
        var mm =''
        var dd =''
        if(today.getMonth()+1 < 10){
          mm = '0'+ (today.getMonth()+1).toString()
        }else{
          mm = today.getMonth()+1
        }
        if(today.getDate() < 10){
          dd = '0' + today.getDate().toString()
        }else{
          dd = today.getDate()
        }
        const date = today.getFullYear()+'-'+mm+'-'+dd;
        return date
      },
      //日期格式轉換
      ChangeDateFormat(UTCDateTime){//UTC 轉 YYYYMMDDhhmmss
        var YYYYMMDD = UTCDateTime.split('T')[0].split('-')
        var hhmmss = UTCDateTime.split('T')[1].split('.')[0].split(':')
        var DateTime = YYYYMMDD[0]+YYYYMMDD[1]+YYYYMMDD[2]+hhmmss[0]+hhmmss[1]+hhmmss[2]
        return DateTime
      },
      //取的兩個經緯度之間的距離
      distance(lat1, lon1, lat2, lon2, unit) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit=="K") { dist = dist * 1.609344 }
            if (unit=="N") { dist = dist * 0.8684 }
            return dist;
        }
      },
      //控制focus的元件
      FocusNext(nextid){
        Vue.prototype.$("#"+nextid ).focus()
      },
      //匯出表格 (other call)
      Export(tablename,id,type){
        var $trs = Vue.prototype.$("#"+id).find("tr"); 
        var str = ""; 
        for (var i = 0; i < $trs.length; i++) {
            var $tds = $trs.eq(i).find("td,th"); 
          for (var j = 0; j < $tds.length; j++) {
            var tds = ''
            if($tds.eq(j)[0].outerText.split(" ").length > 2){
              tds = $tds.eq(j)[0].outerText.replace(" ","")
            }else{
              tds = $tds.eq(j)[0].outerText
            }
            str += tds.replaceAll(/  /g,"").replaceAll(/\r\n|\n/g," ").replaceAll(","," ") + ",";
          } 
          str += "\r\n"; 
        }
        var blob = new Blob(["\ufeff",str], {
          type : "application/octet-stream"
        });
        var filename = tablename + new Date().toLocaleString()  + '.'+ type; 
        var href = URL.createObjectURL(blob);
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.href = href;
        link.download = filename;
        link.click();
      },
      //匯出XLSX From HTMLSTR
      ExportXLSXFromHTMLSingleSheet(tablename, htmlString) {
        // 建立隱藏容器
        const container = document.createElement('div');
        container.style.display = 'none';
        container.innerHTML = htmlString;
        document.body.appendChild(container);
      
        const tables = container.querySelectorAll('table');
        if (tables.length === 0) {
          console.error('HTML 字串內沒有任何 <table>');
          document.body.removeChild(container);
          return;
        }
      
        // 合併所有表格資料
        let allRows = [];
        tables.forEach((table, index) => {
          const sheet = XLSX.utils.table_to_sheet(table);
          const aoa = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
      
          if (index > 0) allRows.push([]); // 表格之間空一行
          allRows = allRows.concat(aoa);
        });
      
        // 時間字串偵測 regex（支援 - 或 /）
        const timeRegex = /^\d{4}[-/]\d{2}[-/]\d{2}[_ T]\d{2}:\d{2}:\d{2}$/;      
        // 手動組出 sheet，時間欄位轉成純文字
        const ws = {};
        const range = { s: { c: 0, r: 0 }, e: { c: 0, r: allRows.length - 1 } };
      
        allRows.forEach((row, rIdx) => {
          range.e.c = Math.max(range.e.c, row.length - 1);
          row.forEach((cell, cIdx) => {
            const addr = XLSX.utils.encode_cell({ r: rIdx, c: cIdx });
            if (typeof cell === 'string' && timeRegex.test(cell.trim())) {
              cell = cell.replace('_',' ')
              // ✅ 符合時間格式 → 強制當字串輸出
              ws[addr] = { t: 's', v: cell };
            } else {
              // 其他自動處理（用 aoa_to_sheet 轉型）
              const tempSheet = XLSX.utils.aoa_to_sheet([[cell]], { origin: { r: rIdx, c: cIdx } });
              ws[addr] = tempSheet[addr];
            }
          });
        });
      
        ws['!ref'] = XLSX.utils.encode_range(range);
      
        // 建立工作簿並匯出
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, ws, '報表');
      
        const filename = `${tablename}.xlsx`;
        XLSX.writeFile(workbook, filename);
      
        // 清除 DOM
        document.body.removeChild(container);
      },
      //匯出XLSX
      // ExportXLSX(tablename,id){
      //   const table = document.querySelector('#'+id);
      //   const workbook = XLSX.utils.table_to_book(table, { sheet: 'test' });
      //   return XLSX.writeFile(workbook, tablename + new Date().toLocaleString() +'.xlsx');
      // },
      ExportXLSX(tablename, id) {
        const table = document.querySelector('#' + id);
      
        // 1. 找出所有 <td> 欄位
        const cells = table.querySelectorAll('td');
      
        // 2. 處理時間格式：將 2025/07/15 15:41:41 轉為 2025-07-15 15:41:41，並強制為文字
        cells.forEach(cell => {
          const text = cell.textContent.trim();
        
          if (/^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/.test(text)) {
            // 插入零寬空白：不會被看到，Excel 無法轉型
            cell.textContent = String.fromCharCode(8203) + text;
          }
        });
      
        // 3. 建立 Excel
        const workbook = XLSX.utils.table_to_book(table, { sheet: 'Sheet1' });
      
        // 4. 加上時間命名
        const filename = tablename + '_' + new Date().toLocaleString() + '.xlsx';
        XLSX.writeFile(workbook, filename);
      },
      ExportCSVForData(tablename, thead, Obj,TimeZone,FleetID) {
        const data = [];
      
        // 生成表頭
        const headers = thead.filter(item => item.name !== '' && item.check).map(item => ({
          title: item.name,
          key: item.index
        }));
      
        // 提取數據行並處理格式
        Obj.forEach(itemtable => {
          const rowData = {};
          headers.forEach(header => {
            const key = header.key;
            let value = itemtable[key];
            // 根據不同欄位進行格式化處理
            if (key === 'rtcTime' || key === 'lastEventLogDateTime') {
              value = value ? this.GetDateFromSTring(value,TimeZone) : '--';
            } else if (key === 'latitude:longitude' && itemtable[key.split(':')[0]] != null) {
              const lat = itemtable[key.split(':')[0]];
              const lng = itemtable[key.split(':')[1]];
              value = `${lat}, ${lng}`;
            } else if ((key === 'speed' || key === 'mileageOfToday' || key === 'mileage') && value != null) {
              value = this.Unit_local !== 'km' ? (value * 0.62137).toFixed(0) : value.toFixed(0);
            } else if (key === 'accState') {
              if (itemtable['connectionState'] === 0) value = this.langObj[this.lang].Offline;
              else if (itemtable['useAcc'] === 0) value = this.langObj[this.lang].Online;
              else if (itemtable['useAcc'] === 1) value = this.NumtoACC(value, itemtable['accType']);
            }else if(key === 'locationArea:locationStreet'){
              value = itemtable[key.split(':')[0]]+' '+itemtable[key.split(':')[1]]
            }else if((key == 'tsD1' || key == 'tsD2' || key == 'tsD3' ||key == 'tsD4' || key == 'analogTemperature1' || key == 'analogTemperature2') && itemtable[key] !=null){
              value = (Number.parseFloat(itemtable[key])/10).toFixed(1)+'°C'
            }else if((key == 'fuelTemperature') && itemtable[key] !=null){
              value = (Number.parseFloat(itemtable[key])/10).toFixed(1)
            }else if((key == 'fuelTankLevel') && itemtable[key] !=null){
              value = (Number.parseFloat(itemtable[key])/10).toFixed(1)
              if(itemtable.FuelVoltagePercentage!=null){
                value = value + '('+itemtable.FuelVoltagePercentage+')';
              }
            }
            else if(key ==='eventName'){
              value = this.EventIDConvertToEventName(itemtable['eventID'],FleetID)
            }else if(key ==='resource'){
              value = this.EventIDConvertToEventName(itemtable['reportId'],FleetID)
            }
            // 加入處理後的值，若為 null 或 undefined，則設為空字串
            rowData[header.title] = (value !== undefined && value !== null) ? value : '--';
          });
          data.push(rowData);
        });
      
        // 將 JSON 轉換為 CSV 並導出
        const worksheet = XLSX.utils.json_to_sheet(data);
        const csv = XLSX.utils.sheet_to_csv(worksheet); // 轉換為 CSV 字串
        // 下載 CSV 檔案
        const blob = new Blob(['\uFEFF'+csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', tablename + new Date().toLocaleString() + '.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      ExportXLSXForData(tablename, thead, Obj,TimeZone,FleetID) {
        const data = [];
      
        // 生成表頭
        const headers = thead.filter(item => item.name !== '' && item.check).map(item => ({
          title: item.name,
          key: item.index
        }));
      
        // 提取數據行並處理格式
        Obj.forEach(itemtable => {
          const rowData = {};
          headers.forEach(header => {
            const key = header.key;
            let value = itemtable[key];
            // 根據不同欄位進行格式化處理
            if (key === 'rtcTime' || key === 'lastEventLogDateTime') {
              value = value ? this.GetDateFromSTring(value, TimeZone) : '--';
            } else if (key === 'latitude:longitude' && itemtable[key.split(':')[0]] != null) {
              const lat = itemtable[key.split(':')[0]];
              const lng = itemtable[key.split(':')[1]];
              value = `${lat}, ${lng}`;
            } else if ((key === 'speed' || key === 'mileageOfToday' || key === 'mileage') && value != null) {
              value = this.Unit_local !== 'km' ? (value * 0.62137).toFixed(0) : value.toFixed(0);
            } else if (key === 'accState') {
              if (itemtable['connectionState'] === 0) value = this.langObj[this.lang].Offline;
              else if (itemtable['useAcc'] === 0) value = this.langObj[this.lang].Online;
              else if (itemtable['useAcc'] === 1) value = this.NumtoACC(value, itemtable['accType']);
            }else if(key === 'locationArea:locationStreet'){
              value = itemtable[key.split(':')[0]]+' '+itemtable[key.split(':')[1]]
            }else if((key == 'tsD1' || key == 'tsD2' || key == 'tsD3' ||key == 'tsD4' || key == 'analogTemperature1' || key == 'analogTemperature2') && itemtable[key] !=null){
              value = (Number.parseFloat(itemtable[key])/10).toFixed(1)+'°C'
            }else if((key == 'fuelTemperature') && itemtable[key] !=null){
              value = (Number.parseFloat(itemtable[key])/10).toFixed(1)
            }else if((key == 'fuelTankLevel') && itemtable[key] !=null){
              value = (Number.parseFloat(itemtable[key])/10).toFixed(1)
              if(itemtable.FuelVoltagePercentage!=null){
                value = value + '('+itemtable.FuelVoltagePercentage+')';
              }
            }
            else if(key ==='eventName'){
              value = this.EventIDConvertToEventName(itemtable['eventID'],FleetID)
            }else if(key ==='resource'){
              value = this.EventIDConvertToEventName(itemtable['reportId'],FleetID)
            }
      
            // 加入處理後的值，若為 null 或 undefined，則設為空字串
            rowData[header.title] = (value !== undefined && value !== null) ? value : '--';
          });
          data.push(rowData);
        });
      
        // 將 JSON 轉換為 Excel 並導出
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, tablename + new Date().toLocaleString() + '.xlsx');
      },
      ExportManager(tablename, id,exportAsCSV) {
        const table = document.querySelector('#' + id);
        if (exportAsCSV) {
            const workbook = XLSX.utils.table_to_book(table, { sheet: 'test', raw: true });// raw: true  避免自動推斷類型
            const sheets = workbook.Sheets;
            // 遍歷每個工作表並匯出為 CSV 文件
            for (const sheetName in sheets) {
              if (sheets.hasOwnProperty(sheetName)) {
                  const currentSheet = sheets[sheetName];
                  // 將工作表轉換為 CSV
                  const csvContent = XLSX.utils.sheet_to_csv(currentSheet);
                  // 添加 BOM (解決中文亂碼問題)
                  const bom = "\uFEFF"; // UTF-8 BOM
                  const finalContent = bom + csvContent;
                  // 創建 Blob 並觸發下載
                  const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
                  const url = URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.setAttribute('href', url);
                  link.setAttribute('download', tablename + new Date().toLocaleString() + '.csv');
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
              }
          }
        } else {
          const workbook = XLSX.utils.table_to_book(table, { sheet: 'test' });
          const sheets = workbook.Sheets;
          // Iterate over each sheet
          for (const sheet in sheets) {
            if (sheets.hasOwnProperty(sheet)) {
                const currentSheet = sheets[sheet];
    
                // Set every cell in this sheet to 's' (text)
                for (const cellAddress in currentSheet) {
                    if (cellAddress[0] === '!') continue; // Skip metadata keys
    
                    const cell = currentSheet[cellAddress];
                    // cell.t = 's'; // Mark the cell as text

                    // Remove single quotes from cell value if it's a string with quotes
                    if (typeof cell.v === 'string' && cell.v.startsWith("'") && cell.v.endsWith("'")) {
                        cell.t = 's';
                        cell.v = cell.v.slice(1, -1); // Remove leading and trailing single quotes
                    }
                }
            }
          }
          // Export the workbook as an Excel file
          XLSX.writeFile(workbook, tablename + new Date().toLocaleString() + '.xlsx');
        }
      },
      //匯出表格 (Manage call)
      Exportfile(Obj,Objthead,filename,Info,Comment,Total){
        let arrayData = [];
        // 最後所有的資料會存在這
        // 取 data 的第一個 Object 的 key 當表頭
        let arrayTitle = Object.keys(Obj[0]);
        if(Info === undefined){
          // 過濾不要的欄位
          arrayTitle = this.FilterData(arrayTitle,Objthead)
        }else{
          //fix Info Comment Total Title content
          var InfoCommentTotalTitlearr = []
          var InfoCommentTotalDataarr = []
          for(var i = 0;i<Info.length;i++){
            InfoCommentTotalTitlearr.push(Info[i].title)
            InfoCommentTotalDataarr.push(Info[i].content)
          }
          for(var i = 0;i<Comment.length;i++){
            InfoCommentTotalTitlearr.push(Comment[i].title)
            InfoCommentTotalDataarr.push(Comment[i].content)
          }
          InfoCommentTotalTitlearr.push(this.langObj[this.lang].total+'：')
          InfoCommentTotalDataarr.push(Total)
          // 過濾不要的欄位
          arrayTitle = this.FilterData(arrayTitle,Objthead)
          //加入資料
          arrayData.push(InfoCommentTotalTitlearr)
          arrayData.push(InfoCommentTotalDataarr)
          //fix Info Comment Total Title content
        }
        arrayData.push(arrayTitle)
        // 取出每一個 Object 裡的 value，push 進新的 Array 裡
        Array.prototype.forEach.call(Obj, d => {
          let items = [];
          Array.prototype.forEach.call(arrayTitle, title => {
            var data = ""
            if(d[title] == null){
              data = d[title]
            }else{
              data = this.filter(d[title].toString())
            }
            let item = data || '無';
            items.push(item);
          });
          //更改arrayTitle為自定義的
          arrayData.push(items)
        })
        if(Info === undefined){
          arrayData[0] = this.FixarrayTitle(arrayTitle,Objthead)
        }else{
          arrayData[2].push(this.FixarrayTitle(arrayTitle,Objthead));
        }
        this.downloadCSV(arrayData,filename)
      },
      //下載CSV擋
      downloadCSV(data,filename){
        let csvContent = '';
        Array.prototype.forEach.call(data, d => {
          let dataString = d.join(',') + '\n';
          csvContent += dataString;
        })
        // 下載的檔案名稱
        var blob = new Blob(["\ufeff",csvContent], {
          type : "application/octet-stream"
        });
        let fileName = filename + new Date().toLocaleString()  + '.csv';
        var href = URL.createObjectURL(blob);
        var link = document.createElement("a");
        document.body.appendChild(link);
        link.href = href;
        link.download = fileName;
        link.click();
        // 建立一個 a，並點擊它
        // let link = document.createElement('a');
        // link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent));
        // link.setAttribute('download', fileName);
        // link.click();
      },
      //將title改為自定義title
      FixarrayTitle(arrayTitle,Objthead){
        for(var i = 0 ; i<arrayTitle.length;i++){
          for(var j = 0 ; j<Objthead.length;j++){
            if(arrayTitle[i] == Objthead[j].index){
              arrayTitle[i] = Objthead[j].name
              break;
            }
          }  
        }
        return arrayTitle
      },
      //過濾沒有要匯出的資料
      FilterData(arrayTitle,Objthead){
        var filterarrayTitle = []
        for(var j = 0 ; j<Objthead.length;j++){
          for(var i = 0 ; i<arrayTitle.length;i++){
            if(arrayTitle[i] == Objthead[j].index){
              switch (Objthead[j].index) {//cameraTypeID轉成cameraTypeName
                case "cameraTypeId":
                  arrayTitle[i] = "cameraTypeName"
                  break;
                case "rearCameraTypeId":
                  arrayTitle[i] = "rearCameraTypeName"
                  break;           
                default:
                  break;
              }
              filterarrayTitle.push(arrayTitle[i]) 
              break;
            }
          }
        }
        return filterarrayTitle
      },
      //過濾特殊字元
      filter(str) {
        var pattern=/[`~!@#$^&*()=|{}';',\\\[\]\<>\?~！@#￥……&*（）——|{}【】'；：""'。，、？]/g;
        return str.replace(pattern,"");
      },
      //車機顏色方向樣式 回傳SRC
      DirectionToImgSrc(Direction,CarColor,objectIconPath){
        var Src = ""
        var CarC = ""
        var directionindex = this.DegreeDirection(Direction)
        switch (CarColor) {
          case 'red':
            CarC = "6"
            break;
          case 'orange':
            CarC = "5"
            break;  
          case 'green':
            CarC = "1"
            break;
          case 'blue':
            CarC = "0"
            break;
          case 'gray':
            CarC = "7"
            break;          
          default:
            break;
        }
        if(objectIconPath != undefined){
          switch (objectIconPath.toLowerCase()) {
            case 'cars':
              objectIconPath = 'Car'
              break;
            case 'ambulance':
                objectIconPath = 'ambulance'
                break;
            case 'bus':
                objectIconPath = 'bus'
                break;
            case 'bus2':
                objectIconPath = 'bus2'
                break;
            case 'dumptruck':
                objectIconPath = 'DumpTruck'
                break;
            case 'excavator':
                objectIconPath = 'Excavator'
                break;
            case 'freightliner':
                objectIconPath = 'Freightliner'
                break; 
            case 'grader':
                objectIconPath = 'grader'
                break;
            case 'motorGrader':
                objectIconPath = 'MotorGrader'
                break; 
            case 'people':
                objectIconPath = 'people'
                break; 
            case 'plate':
                objectIconPath = 'Plate'
                break; 
            case 'motocycle':
                objectIconPath = 'Scooter'
                break;  
            case 'trailer':
                objectIconPath = 'trailer'
                break;  
            case 'truck':
                objectIconPath = 'Truck'
                break;        
            default:
                break;
            }
        }
        Src = require('../static/images/MapIcon/'+objectIconPath+'/CHead'+directionindex+'_S'+CarC+'.gif')
        // Src = require('/assets/images/MapIcon/'+objectIconPath+'/CHead'+dirction+'_S'+CarC+'.gif')
        return Src
      },
      //新增歷史軌跡箭頭
      AddHistoryPathMark(Obj){
        for(var i =0 ;i <Obj.length;i++){
          //console.log(Obj[i])
          switch (this.MapType) {
            case 'Google':
              Vue.prototype.$GoogleMap.AddOverlayMarker(Obj[i].latitude,Obj[i].longitude,'','HistoryMark',Obj[i])  
              break;
            case 'Leaflet':
              Vue.prototype.$LeafletMap.AddMarker(Obj[i],i,'HistoryMarker')
              break;          
            default:
              break;
          }
        }
      },
      //新增歷史軌跡線
      AddHistoryTraceline(Obj){
        switch (this.MapType) {
          case 'Google':
            Vue.prototype.$GoogleMap.AddHistoryTraceline(Obj)  
            break;
          case 'Leaflet':
            Vue.prototype.$LeafletMap.AddHistoryTraceline(Obj)
            break;          
          default:
            break;
        }
      },
      //新增車機點位
      AddUnitMarker(){
        var WatchUnitObj = Vue.prototype.$Vehicle.WatchUnitObj
        this.RemoveUnit()
        setTimeout(() => {
          var MapType = this.MapType
          for(var i=0;i<WatchUnitObj.length;i++){
            var UnitImgGroup ={}
            WatchUnitObj[i].UnitImgGroup = UnitImgGroup
            UnitImgGroup.Unitimg = this.DirectionToImgSrc(WatchUnitObj[i].direction,WatchUnitObj[i].color,WatchUnitObj[i].objectIconPath)
            switch (MapType) {
              case 'Google':            
                Vue.prototype.$GoogleMap.AddOverlayMarker(WatchUnitObj[i].latitude,WatchUnitObj[i].longitude,WatchUnitObj[i].imgsrc,'UnitMarker',WatchUnitObj[i])
                break;
              case 'Leaflet':       
                Vue.prototype.$LeafletMap.AddMarker(WatchUnitObj[i],i,'UnitMarker')
                break;          
              default:
                break;
            }
          }
        }, 200);
      },
      //刪除車機點位
      RemoveUnit(){
        switch (this.MapType) {
          case 'Google':
            Vue.prototype.$GoogleMap.RemoveUnitOverlayMarkers()
            break;
          case 'Leaflet':
            Vue.prototype.$LeafletMap.RemoveUnitMarkerGroup()
            break;       
          default:
            break;
        }
      },
      //刪除歷史軌跡
      RemoveHistory(){
        switch (this.MapType) {
          case 'Google':
            //刪除前一筆歷史軌跡
            if(Vue.prototype.$GoogleMap.HistoryUnitMarker != ''){//刪除前一筆車機打點
              Vue.prototype.$GoogleMap.RemoveOverlayMarkers(Vue.prototype.$GoogleMap.HistoryUnitMarker)
            }
            Vue.prototype.$GoogleMap.RemoveHistoryOverlayMarkers()
            Vue.prototype.$GoogleMap.RemoveHistoryAccOverlayMarkers()
            Vue.prototype.$GoogleMap.RemoveHistoryTraceline()
            Vue.prototype.$GoogleMap.RemoveCameraOverlayMarkers()
            break;
          case 'Leaflet':
            // Vue.prototype.$LeafletMap.RemoveHistoryMarkerGroup()
            if(Vue.prototype.$LeafletMap.HistoryUnitMarker != ''){//刪除前一筆車機打點
              Vue.prototype.$LeafletMap.RemoveHistoryUnitMarker(Vue.prototype.$LeafletMap.HistoryUnitMarker)
            }
            //刪除前一筆歷史軌跡
            Vue.prototype.$LeafletMap.RemoveHistoryTraceline()
            Vue.prototype.$LeafletMap.RemoveCameraMarkerGroup()
            if(Vue.prototype.$LeafletMap.ciLayer != ''){
              Vue.prototype.$LeafletMap.RemoveciLayer()
            }
            if(Vue.prototype.$LeafletMap.AccOnOffciLayer != ''){
              Vue.prototype.$LeafletMap.RemoveAccOnOffciLayer()
            }
            break;        
          default:
            break;
        }
      },
      //取得目前地圖中心點
      GetMapPosition(){
        var LatLngZ ={
          Lat:0,
          Lng:0,
          Z:0
        }
        switch (this.MapType) {
          case 'Google':
            LatLngZ.Lat = Vue.prototype.$GoogleMap.FMap.center.lat()
            LatLngZ.Lng = Vue.prototype.$GoogleMap.FMap.center.lng()
            LatLngZ.Z = Vue.prototype.$GoogleMap.FMap.zoom
            break;
          case 'Leaflet':
            LatLngZ.Lat = Vue.prototype.$LeafletMap.FMap.getCenter().lat
            LatLngZ.Lng = Vue.prototype.$LeafletMap.FMap.getCenter().lng
            LatLngZ.Z = Vue.prototype.$LeafletMap.FMap.getZoom()
            break;       
          default:
            break;
        }
        return LatLngZ
      },
      //紀錄地圖中心點
      LogMapPosition(Page){
        var lat;
        var lng;
        var zoom;
        switch (this.MapType) {
          case 'Google':
            lat = Vue.prototype.$GoogleMap.FMap.center.lat()
            lng = Vue.prototype.$GoogleMap.FMap.center.lng()
            zoom = Vue.prototype.$GoogleMap.FMap.zoom
            break;
          case 'Leaflet':
            lat = Vue.prototype.$LeafletMap.FMap.getCenter().lat
            lng = Vue.prototype.$LeafletMap.FMap.getCenter().lng
            zoom = Vue.prototype.$LeafletMap.FMap.getZoom()
            break;       
          default:
            break;
        }
        localStorage.setItem(Page+'LatLngZ',JSON.stringify({lat:lat,lng:lng,zoom:zoom}))//紀錄經緯度
        return JSON.parse(localStorage.getItem(Page+'LatLngZ'))
      },
      //更改深淺色系
      SetTheme(theme){
        //Hash
        // switch (theme) {
        //   case 'black':
        //     Vue.prototype.$("#skincss").attr("href", 'static/black_theme.css')
        //     localStorage.setItem('theme','black')
        //     break;
        //   case 'white':
        //     Vue.prototype.$("#skincss").attr("href",'static/white_theme.css')
        //     localStorage.setItem('theme','white')
        //     break;  
        //   default:
        //     Vue.prototype.$("#skincss").attr("href", 'static/white_theme.css')
        //     this.theme = 'white'
        //     localStorage.setItem('theme','white')
        //     break;
        // }
        //History
        switch (theme) {
          case 'black':
            Vue.prototype.$("#skincss").attr("href", '/static/black_theme.css?v=4.2606.0')
            localStorage.setItem('theme','black')
            break;
          case 'white':
            Vue.prototype.$("#skincss").attr("href",'/static/white_theme.css?v=4.2606.0')
            localStorage.setItem('theme','white')
            break;  
          default:
            Vue.prototype.$("#skincss").attr("href", '/static/white_theme.css?v=4.2606.0')
            this.theme = 'white'
            localStorage.setItem('theme','white')
            break;
        }
      },
      //更改車機到最上層
      SetUnitmarkZindex(Unit){
        switch (this.MapType) {
          case 'Leaflet':
            Vue.prototype.$LeafletMap.SetUnitmarkZindex(Unit)
            break;
          case 'Google':
            Vue.prototype.$GoogleMap.SetUnitmarkZindex(Unit)
            break;        
          default:
            break;
        }
      },
      //設定地圖中心點
      SetCenter(Item){
        var Zoom = Vue.prototype.$Global.FocusZoom
        switch (this.MapType) {
          case 'Leaflet':
            Vue.prototype.$LeafletMap.SetCenter(Item.latitude,Item.longitude,Zoom)
            break;
          case 'Google':
            Vue.prototype.$GoogleMap.SetCenter(Item.latitude,Item.longitude,Zoom)
            break;        
          default:
            break;
        }
      },
      //設定地圖中心點
      SetCenterLatLngZ(lat,lng,z){
        switch (this.MapType) {
          case 'Leaflet':
            if(z == 'noChange'){
              z=Vue.prototype.$LeafletMap.FMap.getZoom()
            }
            Vue.prototype.$LeafletMap.SetCenter(lat,lng,z)
            break;
          case 'Google':
            if(z == 'noChange'){
              z=Vue.prototype.$GoogleMap.FMap.getZoom()
            }
            Vue.prototype.$GoogleMap.SetCenter(lat,lng,z)
            break;        
          default:
            break;
        }
      },
      //多車鎖定
      Multifocus(Item){
        switch (this.MapType) {
          case 'Leaflet':
            Vue.prototype.$LeafletMap.Multifocus(Item)
            break;
          case 'Google':
            Vue.prototype.$GoogleMap.Multifocus(Item)
            break;        
          default:
            break;
        }
      },
      //車機外層光圈閃爍設定
      SetDotOn(UnitID){
        Vue.prototype.$(".dot").removeClass('dot-on')
        Vue.prototype.$("#dot"+UnitID).addClass('dot-on')
      },
      //object排序
      sortByKey(array, key, type) {
        switch (type) {
          case 'Num':
            return array.sort(function(a, b) {
              var x = Number(a[key]) || 0;
              var y = Number(b[key]) || 0;
              return x - y;
            });
          default:
            return array.sort(function(a, b) {
              // 確保轉為字串且防呆，避免 null/undefined 呼叫 toLowerCase 報錯
              var x = (a[key] !== null && a[key] !== undefined) ? String(a[key]).toLowerCase() : '';
              var y = (b[key] !== null && b[key] !== undefined) ? String(b[key]).toLowerCase() : '';
              return x.localeCompare(y);
            });
        }
      },
      //回到user設定的經緯度
      BackHomeLatLng(){
        Vue.prototype.$APIjs.GetUserLatLng(localStorage.getItem('token'),1).then(result=>{
          if(result.Status == 'success'){
            this.SetCenterLatLngZ(result.obj.cy,result.obj.cx,result.obj.cz)
          }else{
            alert(Vue.prototype.$Global.langObj[Vue.prototype.$Global.lang].failed_to_get_initial_map_location)
          }
        })
      },
      //Json過濾資料
      JsonFilter(code,data,filterfield) {
        return data.filter(
          function(data) {
            return data[filterfield] == code
          }
        );
      },
      //距離現在多久
      differenceCurrentTime(DateTime){
        return (new Date(new Date().toISOString().replace(/(\.\d{3})?Z/, '')).getTime() - new Date(DateTime).getTime())
      },
      //值反查key
      findKey (data,value, compare = (a, b) => a === b) {
        return Object.keys(data).find(k => compare(data[k], value))
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/Global.js